import { set } from "lodash";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { useConsumerDatasource } from "../../block-system/blocks/MarkdownText/hooks/useConsumerDatasource";

export function useContentDatasource() {
  const consumerDatasource = useConsumerDatasource();

  const router = useRouter();
  const routerParams = useMemo(
    () =>
      Object.keys(router.query).reduce(
        (acc, key) => set(acc, `params.${key}`, router.query[key]),
        {}
      ),
    [router.query]
  );

  return useMemo(() => {
    return {
      data: {
        ...consumerDatasource,
        ...routerParams,
      },
    };
  }, [consumerDatasource, routerParams]);
}
